export default (country, state = '') => {
    const vCountry = country ? country.trim().toUpperCase() : ''

    if (vCountry === 'VN') return 'Việt Nam'
    if (vCountry === 'SG') return 'Singapore'
    if (vCountry !== 'US') return 'Quốc tế'

    const vState = state ? state.trim().toUpperCase() : ''
    const internationalUSStates = ['AE', 'AA', 'AO', 'AP', 'PR', 'VI', 'GU', 'MP']

    if (!vState || internationalUSStates.includes(vState)) {
        return 'Quốc tế'
    }

    return 'Thường (US)'
}

